/* eslint-disable react/require-default-props */
import * as React from 'react';
import {Image, View} from 'react-native';
import {isString} from 'lodash';

import {CoachInfoCard, SearchAndFilter} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {styles} from './Avatar.style';
import DefaultAvatar from './DefaultAvatar';

interface AvatarProps {
  size?: number;
  isCoach?: boolean;
  avatarUrl?: string | null;
  avatarKey?: string | null;
  accessible?: boolean;
  fullName?: string | null;
  accessibilityRole?: string;
  nativeID?: string;
  testID?: string;
  key?: string;
}

export const Avatar: React.FC<AvatarProps> = ({
  size = 40,
  isCoach = true,
  avatarUrl = null,
  avatarKey = null,
  accessible,
  fullName,
  accessibilityRole,
  nativeID,
  testID,
  key,
}) => {
  const variant = isCoach ? 'coach' : 'client';
  const accessibilityLabel = fullName
    ? `${fullName}'s profile picture`
    : `coach's profile picture`;
  if (avatarUrl) {
    const style = [styles.base, {width: size, height: size}];
    const imageStyle = [styles.image, {width: size, height: size}];
    const source = isString(avatarUrl) ? {uri: avatarUrl} : avatarUrl;

    return (
      <View
        style={style}
        testID={CoachInfoCard.profilePicture}
        accessible={true}
        accessibilityRole="image"
        accessibilityLabel={accessibilityLabel}
        nativeID={nativeID}>
        <Image
          key={key}
          source={source}
          style={imageStyle}
          accessible={false}
          accessibilityLabel={accessibilityLabel}
          {...testProperties(testID ?? SearchAndFilter.avatar)}
          importantForAccessibility="no-hide-descendants"
        />
      </View>
    );
  }

  return (
    <DefaultAvatar
      size={size}
      variant={variant}
      avatarKey={avatarKey ?? ''}
      accessible={accessible}
      accessibilityRole={accessibilityRole}
      accessibilityLabel={accessibilityLabel}
      nativeID={nativeID}
      testID={testID}
    />
  );
};

export default Avatar;
